import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { Filter, Grid, Condition } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { ConditionsBuilder } from '../../../elements';
import { message } from 'antd';

export function FilterDetailsForm(props: { filter?: Filter; onSaved?: (filter: Filter) => void }) {
  const [submitting, setSubmitting] = useState(false);
  const [loadingDataSets, setLoadingDataSets] = useState(false);
  const [dataSets, setDataSets] = useState<Grid[]>([]);
  const [selectedDataSet, setSelectedDataSet] = useState<Grid>();
  const [conditions, setConditions] = useState<Condition>();

  const [form] = Form.useForm();

  const filter = { ...props.filter, dataSetId: props.filter?.grid?.id };

  useEffect(() => {
    if (props.filter?.grid) {
      setSelectedDataSet(props.filter?.grid);
    }
    if (props.filter?.conditions) {
      setConditions(props.filter.conditions);
    }
  }, [props.filter?.grid, props.filter?.conditions]);

  useEffect(() => {
    setLoadingDataSets(true);
    apiClient
      .get('grids')
      .then((response: any) => {
        setDataSets(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoadingDataSets(false);
      });
  }, []);

  const onDataSetChange = (value: string) => {
    setSelectedDataSet(dataSets.find(t => t.id === value));
    setConditions(undefined);
  };

  const onConditionsChange = (value: Condition) => {
    setConditions(value);
  };

  const onEditFinish = (values: any) => {
    const body = {
      ...values,
      conditions,
    };
    setSubmitting(true);
    apiClient
      .put(`filters/${props.filter?.id}`, body)
      .then((response: any) => {
        setSubmitting(false);
        message.success('Filtre başarıyla kaydedildi.');
        if (props.onSaved) {
          props.onSaved(response.data);
        }
      })
      .catch((reason: any) => {
        setSubmitting(false);
        apiErrorMessage(reason);
      });
  };

  return (
    <Form layout="vertical" onFinish={onEditFinish} form={form} initialValues={filter}>
      <Form.Item
        label="İsim"
        name="name"
        wrapperCol={{ span: 8, xs: 24, sm: 24, md: 12, lg: 10, xl: 10, xxl: 8 }}
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            pattern: /^[a-zA-Z0-9ıİğĞüÜşŞöÖçÇ][a-zA-Z0-9_\-ıİğĞüÜşŞöÖçÇ\s]*$/,
            message: 'Sadece harf, rakam, boşluk, - ve _ karakteri kullanılabilir',
          },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Açıklama"
        name="description"
        wrapperCol={{ span: 8, xs: 24, sm: 24, md: 12, lg: 10, xl: 10, xxl: 8 }}
        rules={[{ max: 400, message: 'En fazla 400 karakter' }]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item
        label="Veri seti"
        name="dataSetId"
        wrapperCol={{ span: 8, xs: 24, sm: 24, md: 12, lg: 10, xl: 10, xxl: 8 }}
        rules={[{ required: true, message: 'Zorunlu alan' }]}
      >
        <Select options={dataSets.map(t => ({ label: t.name, value: t.id }))} loading={loadingDataSets} onChange={onDataSetChange} />
      </Form.Item>

      <Form.Item label="Koşullar" name="conditions">
        <ConditionsBuilder
          dataSetId={selectedDataSet?.id}
          pendingSelectMessage="Koşullar için bir veri seti seçin"
          initialConditions={props.filter?.conditions}
          onChange={onConditionsChange}
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={submitting}>
          Kaydet
        </Button>
      </Form.Item>
    </Form>
  );
}
